import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { CodePreview } from './CodePreview';
import { TabPanel, Tabs } from './Tab';
export var TabComp = function (_a) {
    var scripts = _a.scripts;
    var tabs = useMemo(function () { return scripts.map(function (script) { return ({ label: script.label }); }); }, [scripts]);
    return (_jsx(Tabs, { variant: 'enclosed', tabs: tabs, children: scripts.map(function (script) { return (_jsx(TabPanel, { children: _jsx(CodePreview, { codeBlockClassName: 'vas-border vas-border-gray-300 -vas-mt-px', label: script.label }) }, "tab-panel-".concat(script.label))); }) }));
};
